import type React from "react";

export function preventContextMenu(
  e: React.MouseEvent<HTMLVideoElement, MouseEvent>
) {
  e.preventDefault();
  e.stopPropagation();
  return false;
}

export function keyboardActivationProps() {
  return {
    role: "button" as const,
    tabIndex: 0,
    onKeyDown(event: React.KeyboardEvent<HTMLElement>) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        event.currentTarget.click();
      }
    },
  };
}
